// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.insights-container {
    margin-left: 100px;
    flex: 1 1;
    overflow-y: auto;
    margin-top: 50px;
    padding-bottom: 100px;
}

.chart-container {
    margin-top: 20px;
}

.insights-title {
    font-size: 40px;
    font-weight: bold;
    margin-bottom: 25px;
}

.graph-breakdown {
    margin-top: 30px;
    height: 450px;
    width: 100%;
    justify-content: center;
    align-items: center;
}


.selected-title {
    font-size: 20px;;
    margin-top: 20px;
}

.selected-node-type {
    font-size: 16px;
    margin-top: 10px;
}

.insights-select-node-title {
    margin-top: 20px;
    background-color: #1c83e11a;
    color: #004280;
    padding: 15px;
    width: 80%;
    border-radius: 8px;

}

.selected-node-container {
    margin-top: 40px;
    width: 90%;
    border-radius: 8px;
}

hr {
    margin: 20px auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/componentsCSS/Dashboard.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,SAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;;AAGA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,cAAc;IACd,aAAa;IACb,UAAU;IACV,kBAAkB;;AAEtB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["\n.insights-container {\n    margin-left: 100px;\n    flex: 1;\n    overflow-y: auto;\n    margin-top: 50px;\n    padding-bottom: 100px;\n}\n\n.chart-container {\n    margin-top: 20px;\n}\n\n.insights-title {\n    font-size: 40px;\n    font-weight: bold;\n    margin-bottom: 25px;\n}\n\n.graph-breakdown {\n    margin-top: 30px;\n    height: 450px;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n}\n\n\n.selected-title {\n    font-size: 20px;;\n    margin-top: 20px;\n}\n\n.selected-node-type {\n    font-size: 16px;\n    margin-top: 10px;\n}\n\n.insights-select-node-title {\n    margin-top: 20px;\n    background-color: #1c83e11a;\n    color: #004280;\n    padding: 15px;\n    width: 80%;\n    border-radius: 8px;\n\n}\n\n.selected-node-container {\n    margin-top: 40px;\n    width: 90%;\n    border-radius: 8px;\n}\n\nhr {\n    margin: 20px auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
